<template>
    <div>
        <draggable-accordion
            class="mb-2"
            v-for="content in props.data.contents"
            :unique_id="content.unique_id"
            :edit="content.edit"
            @remove="removeContent"
            @toggle="toggleContent(content)"
        >
            <template #title>{{ contentName }}</template>
            <template #content>
                <div class="grid lg:grid-cols-2 gap-6 gap-y-4">
                    <text-field
                        label="Button"
                        v-model="content.button"
                        placeholder="Enter button text"
                    />
                    <text-field
                        label="URL"
                        v-model="content.url"
                        placeholder="https://"
                        :prefixes="['https://', 'http://']"
                    />
                </div>
            </template>
        </draggable-accordion>

        <div class="flex justify-between items-center">
            <btn type="secondary" size="small" icon-name="add-circle" @click="addContent">Add {{ contentName }}</btn>
            <div class="flex items-center gap-2">
                <div v-if="data.display_content" class="flex items-center">
                    <span class="text-sm text-gray-400 mr-1">Columns:</span>
                    <select
                        :value="data.columns_count || 3"
                        @change="data.columns_count = Number($event.target.value)"
                        class="border-0 focus:ring-0 leading-4 text-sm text-gray-500 p-0 pr-8 bg-transparent cursor-pointer"
                    >
                        <option :value="2">2</option>
                        <option :value="3">3</option>
                    </select>
                </div>

                <div class="flex justify-between items-center">
                    <toggle
                        name="columns_toggle"
                        size="medium"
                        v-model="data.display_content"
                    />
                    <span class="text-sm font-medium">Display in columns</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import {defineProps} from 'vue';
import {uniqueId} from '../helpers';

const contentName = 'CTA';

const props = defineProps({
    data: Object
});

props.data.display_content = props.data?.display_content ?? false;
if (!props.data.columns_count) props.data.columns_count = 3;
props.data.contents = props.data?.contents ?? [];

// Ensure only one content is open at initialization
let foundFirstOpen = false;
props.data.contents.forEach(content => {
    if (content.edit) {
        if (foundFirstOpen) {
            content.edit = false;
        } else {
            foundFirstOpen = true;
        }
    }
});

const toggleContent = (element) => {
    const isOpening = !element.edit;
    if (isOpening) {
        props.data.contents.forEach(content => {
            if (content.unique_id !== element.unique_id) {
                content.edit = false;
            }
        });
    }
    element.edit = !element.edit;
}

const addContent = () => {
    // Close all existing content
    props.data.contents.forEach(content => {
        content.edit = false;
    });
    
    props.data.contents.push({
        unique_id: uniqueId(),
        edit: true,
        button: '',
        url: '',
    });
}

const removeContent = (uniqueId) => {
    props.data.contents.splice(
        props.data.contents.findIndex(content => content.unique_id === uniqueId)
    , 1);
}
</script>
